//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex'
import Skeleton from '@/components/MarketsSkeleton.vue'
import SelectOptions from '@/components/SelectOptions.vue'
import { createTickerLink } from '@/utils/string.util'
import firebase from 'firebase/app'
export default {
	name: 'markets',
	data: () => ({
		loading: true,
		loadingSymbol: null,
		sortPriceChange: 'INCREASE',
		sortVolume: 'INCREASE',
		exchange: 'BINANCE',
		exchanges: ['BINANCE', 'KUCOIN', 'HUOBI', 'BITTREX', 'BITHUMB'],
		tickerPair: 'BTC',
		tickerPairs: ['BTC'],
		selected: null,

		filterTickers: '',
		pairTitle: '',
		filter: '',
		tickers: [],
		data: [],
		favList: [],
		current: '',
	}),
	components: {
		Skeleton,
		SelectOptions,
	},

	filters: {
		btcVol: (val) => parseFloat(val).toFixed(1),
		btcPrice: (val) =>
			parseFloat(val)
				.toFixed(10)
				.replace(/([0-9]+(\.[0-9]+[1-9])?)(\.?0+$)/, '$1'),

		shorter: (value) => (value = Math.trunc(value * 100) / 100),
		shorterA: (value) => (value = value * 1),
		btc: (value) => (value = Math.trunc(value).toFixed(8)),
	},

	computed: {
		...mapGetters(['getMarketsFavs']),

		exchangeFavorites() {
			const found = this.getMarketsFavs.find(
				(el) => el.exchange.toUpperCase() === this.exchange.toUpperCase()
			)
			return found ? found.favorites : []
		},
		getDataParams() {
			return {
				exchange: this.exchange,
				pair: this.tickerPair,
			}
		},

		filteredTickers() {
			try {
				return this.tickers.filter((el) =>
					el.ticker.toLowerCase().match(this.filter.toLowerCase())
				)
			} catch (e) {
				return this.tickers
			}
		},
	},
	watch: {
		getDataParams(newVal, oldVal) {
			const { exchange: newExchange, pair: newPair } = newVal
			const { exchange: oldExchange, pair: oldPair } = oldVal
			if (newVal === oldVal) return
			if (newExchange !== oldExchange && newPair !== 'BTC') {
				this.tickerPair = 'BTC'
			}
			this.fetchData(this.exchange, this.tickerPair)
		},
	},

	async created() {
		await this.fetchData(this.exchange, this.tickerPair)
	},

	methods: {
		redirect(ticker) {
			const { symbol, pair } = ticker
			const link = createTickerLink(this.exchange.toUpperCase(), symbol, pair)
			window.open(link)
		},
		...mapActions([
			'getMarketTickers',
			'addToMarketsFavs',
			'deleteFromMarketsFavs',
		]),

		async addToExchangeFavs(t) {
			const { ticker, symbol, pair } = t
			this.loadingSymbol = symbol
			const currentUser = firebase.auth().currentUser
			const link = createTickerLink(this.exchange.toUpperCase(), symbol, pair)
			if (currentUser) {
				await this.addToMarketsFavs({
					exchange: this.exchange.toUpperCase(),
					ticker: { link, ticker, symbol, pair },
				})
			} else {
				this.$router.push('/login')
			}
			this.loadingSymbol = null
		},
		async deleteFromExchangeFavs(ticker) {
			const { id, symbol } = this.exchangeFavorites.find(
				(val) => val.ticker === ticker.ticker
			)
			this.loadingSymbol = symbol
			await this.deleteFromMarketsFavs({
				id,
				exchange: this.exchange,
			})
			this.loadingSymbol = null
		},

		async fetchData(exchange, pair) {
			try {
				this.loading = true
				const { length, tickers, pairs } = await this.getMarketTickers({
					exchange,
					pair,
				})
				this.tickerPairs = pairs && pairs.length ? ['ALL', ...pairs] : null
				this.tickers = tickers
				this.sortByVol(this.tickers)
				this.loading = false
			} catch (e) {
				this.loading = false
				console.warn('Error while executing', e)
			}
		},
		selectExchange(exchange) {
			this.exchange = exchange
		},
		selectPair(pair) {
			this.tickerPair = pair
		},
		// ОБЪЕМ по возрастанию
		sortByVol(arr) {
			this.tickers.sort((a, b) => {
				return b.volumePair - a.volumePair
			})
			this.sortVolume = 'INCREASE'
		},
		// ОБЪЕМ  по убыванию
		sortDecreaseByVol(arr) {
			this.tickers.sort((a, b) => {
				return a.volumePair - b.volumePair
			})
			this.sortVolume = 'DECREASE'
		},

		// ЦЕНА по возрастанию
		sortByPrice(arr) {
			this.tickers.sort((a, b) => {
				return b.priceChangePercent - a.priceChangePercent
			})
			this.sortPriceChange = 'INCREASE'
		},

		// ЦЕНА по убыванию
		sortDecreaseByPrice(arr) {
			this.tickers.sort((a, b) => {
				return a.priceChangePercent - b.priceChangePercent
			})
			this.sortPriceChange = 'DECREASE'
		},
	},
}
